
import apiurl from "./apiurl.js";
import axios from 'axios';

const consultaDLQ= {
    getDLQ: async (idToken) =>        
    axios({
        'method':'GET',
        'url':apiurl +'consultaDLQ',
        'headers': {
            'content-type':'application/json',
            'Authorization':"Bearer "+idToken
        },
        'crossdomain': true,
    }),
    redriveDLQ: async (queueName,idToken) =>        
    axios({
        'method':'POST',
        'url':apiurl +'redriveDLQ',
        'data': {dlqKey:queueName},
        'headers': {
            'content-type':'application/json',
            'Authorization':"Bearer "+idToken
        },
        'crossdomain': true,
    })  
};

export default consultaDLQ;
